export default "__VITE_ASSET__Do8F7Jt___"